import Image from "@/components/AppImage";
import how_work_icon_1 from "/public/img/how-work-icon-1.png";
import how_work_icon_2 from "/public/img/how-work-icon-2.png";
import how_work_icon_3 from "/public/img/how-work-icon-3.png";

const HowItsWork = () => {
  return (
    <section className="how-works index8">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-7">
              <div className="section-header text-center">
                <h2 className="title">How OracleMarket keeps you informed</h2>
                <p>
                  Pick the signals that matter, choose where they should land,
                  and throttle noise so only actionable events break through.
                </p>
              </div>
            </div>
          </div>
          <div className="row cus-mar">
            <div className="col-lg-4 col-md-4">
              <div className="single-item active text-center">
                <div className="icon-area">
                  <Image src={how_work_icon_1} alt="icon" />
                </div>
                <div className="text-area">
                  <h5>Choose alert topics</h5>
                  <p>
                    Successful captures, failed attempts, FX moves, subscription
                    renewals, or suspicious logins—toggle each channel
                    independently.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-item active text-center">
                <div className="icon-area">
                  <Image src={how_work_icon_2} alt="icon" />
                </div>
                <div className="text-area">
                  <h5>Route to inbox, SMS, or push</h5>
                  <p>
                    Send high-priority funding events to SMS, keep marketing
                    noise in email, and mirror everything inside the OracleMarket app
                    inbox.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-item active text-center">
                <div className="icon-area">
                  <Image src={how_work_icon_3} alt="icon" />
                </div>
                <div className="text-area">
                  <h5>Act in one tap</h5>
                  <p>
                    Deep links jump straight to the transaction, beneficiary, or
                    security setting so you resolve issues in seconds.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItsWork;
